import * as Accordion from '@radix-ui/react-accordion';
import useNavItems from 'src/components/Navigation/hooks/useNavItems';
import useNavigationState from 'src/components/Navigation/hooks/useNavigationState';
import MobileNavAccordionContent from 'src/components/Navigation/MobileNav/MobileNavAccordion/MobileNavAccordionContent';
import MobileNavAccordionTrigger from 'src/components/Navigation/MobileNav/MobileNavAccordion/MobileNavAccordionTrigger';

export default function MobileNavAccordion() {
	const navigationState = useNavigationState();

	const navItems = useNavItems({ screenSize: 'mobile' });

	return (
		<Accordion.Root type="single" collapsible>
			{navItems.map(([navCategory, navOption]) => {
				return (
					<Accordion.Item key={navCategory} value={navCategory}>
						<Accordion.Header>
							<Accordion.Trigger asChild>
								<MobileNavAccordionTrigger
									navOption={navOption}
									navCategory={navCategory}
									handleNavigation={navigationState.handleNavigation}
								/>
							</Accordion.Trigger>
						</Accordion.Header>
						{navOption.type === 'categoryOption' && (
							<Accordion.Content asChild>
								<MobileNavAccordionContent
									navOption={navOption}
									handleNavigation={navigationState.handleNavigation}
								/>
							</Accordion.Content>
						)}
					</Accordion.Item>
				);
			})}
		</Accordion.Root>
	);
}
